import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(`${process.env.REACT_APP_API_HOST}/project_cost_center/`, data);
};

const getAll = async () => {
  return await httpClient.get(`${process.env.REACT_APP_API_HOST}/project_cost_center/?page[size]=100`);
};

const getAllExtend = async (id) => {
  return await httpClient.post(`${process.env.REACT_APP_API_HOST}/cost_centers_by_project/${id}/`);
};

const get = async (id) => {
  return await httpClient.get(`${process.env.REACT_APP_API_HOST}/project_cost_center/${id}`);
};

const put = async (id, data) => {
  return await httpClient.put(`${process.env.REACT_APP_API_HOST}/project_cost_center/${id}/`, data);
};

const remove = async (id) => {
  return await httpClient.delete(`${process.env.REACT_APP_API_HOST}/project_cost_center/${id}`);
};

export {
  post,
  getAll,
  get,
  put,
  remove,
  getAllExtend,
}
